import Captcha from 'components/Captcha/Captcha';

export default Captcha;
